import React from 'react';
import "../../styles/chats/user_search_tab.css";
import { useSearchContext } from './searchContext';
import { Link } from 'react-router-dom';

const UserSearchTab = ({setUserImage, setUserName, id, onClose}) => {
    const {setUserId} = useSearchContext();

    const onSendMessage = () => {
        setUserId(id);
        onClose(false);
    }

    return(
        <div className="user_search_tab">
            <Link className='user_search_tab_link' to={id === "" || id === null ? null : `/main_back/chats/${setUserName}`}><div onClick={onSendMessage} className="user_search_tab_row">
                <img className="user_search_tab_image" alt='profile' src={setUserImage} />
                <p className="user_search_tab_name">{setUserName}</p>
                <p className="user_search_tab_chat">message</p>
            </div></Link>
            <div className="user_search_tab_divider"></div>
        </div>
    );
};

export default UserSearchTab;